<template>
  <div style="display: flex">
    <div class="star-container">
      <font-awesome-icon size="2x" class="star" :style="{ height: `${height}px`, width: `${width}px` }" :icon="['fas', 'star']" />
      <div class="backround-container">
        <div
          class="left"
          :style="{
            display: rating <= 0 ? 'none' : null,
            background: getPrimaryColor(),
            width: rating <= 1 ? `${rating * width}px` : `${width}px`,
            height: `${height}px`,
            borderRadius: rating >= 1 ? '2px' : null,
          }"
        ></div>
        <div
          class="right"
          :style="{
            display: rating >= 1 ? 'none' : null,
            background: '#CBD5E1',
            width: rating > 0 && rating <= 1 ? `${width - rating * width}px` : `${width}px`,
            height: `${height}px`,
            borderRadius: rating <= 0 ? '2px' : null,
          }"
        ></div>
      </div>
    </div>
    <div class="star-container">
      <font-awesome-icon size="2x" class="star" :style="{ height: `${height}px`, width: `${width}px` }" :icon="['fas', 'star']" />
      <div class="backround-container">
        <div
          class="left"
          :style="{
            display: rating <= 1 ? 'none' : null,
            background: getPrimaryColor(),
            width: rating <= 2 ? `${(rating - 1) * width}px` : `${width}px`,
            height: `${height}px`,
            borderRadius: rating >= 2 ? '2px' : null,
          }"
        ></div>
        <div
          class="right"
          :style="{
            display: rating >= 2 ? 'none' : null,
            background: '#CBD5E1',
            width: rating > 1 && rating <= 2 ? `${width - (rating - 1) * width}px` : `${width}px`,
            height: `${height}px`,
            borderRadius: rating <= 1 ? '2px' : null,
          }"
        ></div>
      </div>
    </div>
    <div class="star-container">
      <font-awesome-icon size="2x" class="star" :style="{ height: `${height}px`, width: `${width}px` }" :icon="['fas', 'star']" />
      <div class="backround-container">
        <div
          class="left"
          :style="{
            display: rating <= 2 ? 'none' : null,
            background: getPrimaryColor(),
            width: rating <= 3 ? `${(rating - 2) * width}px` : `${width}px`,
            height: `${height}px`,
            borderRadius: rating >= 3 ? '2px' : null,
          }"
        ></div>
        <div
          class="right"
          :style="{
            display: rating >= 3 ? 'none' : null,
            background: '#CBD5E1',
            width: rating > 2 && rating <= 3 ? `${width - (rating - 2) * width}px` : `${width}px`,
            height: `${height}px`,
            borderRadius: rating <= 2 ? '2px' : null,
          }"
        ></div>
      </div>
    </div>
    <div class="star-container">
      <font-awesome-icon size="2x" class="star" :style="{ height: `${height}px`, width: `${width}px` }" :icon="['fas', 'star']" />
      <div class="backround-container">
        <div
          class="left"
          :style="{
            display: rating <= 3 ? 'none' : null,
            background: getPrimaryColor(),
            width: rating <= 4 ? `${(rating - 3) * width}px` : `${width}px`,
            height: `${height}px`,
            borderRadius: rating >= 4 ? '2px' : null,
          }"
        ></div>
        <div
          class="right"
          :style="{
            display: rating >= 4 ? 'none' : null,
            background: '#CBD5E1',
            width: rating > 3 && rating <= 4 ? `${width - (rating - 3) * width}px` : `${width}px`,
            height: `${height}px`,
            borderRadius: rating <= 3 ? '2px' : null,
          }"
        ></div>
      </div>
    </div>
    <div class="star-container">
      <font-awesome-icon size="2x" class="star" :style="{ height: `${height}px`, width: `${width}px` }" :icon="['fas', 'star']" />
      <div class="backround-container">
        <div
          class="left"
          :style="{
            display: rating <= 4 ? 'none' : null,
            background: getPrimaryColor(),
            width: rating <= 5 ? `${(rating - 4) * width}px` : `${width}px`,
            height: `${height}px`,
            borderRadius: rating >= 5 ? '2px' : null,
          }"
        ></div>
        <div
          class="right"
          :style="{
            display: rating >= 5 ? 'none' : null,
            background: '#CBD5E1',
            width: rating > 4 && rating <= 5 ? `${width - (rating - 4) * width}px` : `${width}px`,
            height: `${height}px`,
            borderRadius: rating <= 4 ? '2px' : null,
          }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "reviewStars",
  props: {
    rating: Number,
    width: {
      type: Number,
      default: 16,
    },
    height: {
      type: Number,
      default: 16,
    },
  },
}
</script>

<style lang="scss" scoped>
.star-container {
  display: flex;
  position: relative;
  padding-right: 4px;
  .backround-container {
    display: flex;
    .left {
      border-radius: 2px 0px 0px 2px;
    }
    .right {
      border-radius: 0px 2px 2px 0px;
    }
  }
  .star {
    transform: scale(0.7);
    color: white;
    position: absolute;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/commons/ReviewStar.vue